



















































import { Component } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  AlertMessage,
  bibliographyContentApi,
  BibliographyRealDetailContent,
  ErrorMessage
} from '@/api'
import { cloneDeep } from 'lodash'
import CollectionContentTreeItemInfoTable from '@/components/organisms/CollectionContentTreeItemInfoTable/CollectionContentTreeItemInfoTable.vue'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { AlertFactory } from '@/factory'
import { AlertCodeCLT00042 } from '@/types'

export interface ModalContentSortInterface {
  bibliographyRealId: number
  tableItems: BibliographyRealDetailContent[]
  onClickRegisterCallback: () => void
}

@Component({
  components: {
    CollectionContentTreeItemInfoTable,
    ModalFooter
  }
})
export default class ModalContentSort extends ModalComponentBaseVue {
  dialog: boolean = false

  tableBodyHeight: number = 0

  bibliographyRealId: number = 0

  defaultTableItems: BibliographyRealDetailContent[] = []

  tableItems: BibliographyRealDetailContent[] = []

  registerCallback?: () => void

  // refによる直接呼出し前提の作りとなっている
  open(params: ModalContentSortInterface): void {
    this.bibliographyRealId = params.bibliographyRealId
    this.tableItems = cloneDeep(params.tableItems)
    this.defaultTableItems = cloneDeep(params.tableItems)
    this.registerCallback = params.onClickRegisterCallback
    window.addEventListener('resize', this.calculateTableHeight)
    this.dialog = true
    this.$nextTick(this.calculateTableHeight)
  }

  close(): void {
    this.tableBodyHeight = 0
    window.removeEventListener('resize', this.calculateTableHeight)
    this.dialog = false
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-content-sort')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onClickRegistration(): void {
    const alert = AlertFactory.create(AlertCodeCLT00042, '内容')
    alertStore.setItem(alert)
    this.$modalAlert.open({
      modalType: 'WARN',
      onOkClick: this.updateBibliographyContentSortOrder
    })
  }

  async updateBibliographyContentSortOrder() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographyContentApi.updateSortOrder({
        bibliographyRealId: this.bibliographyRealId,
        bibliographyContents: this.tableItems.map(item => {
          return {
            id: item.bibliographyId,
            revision: item.revision
          }
        })
      })
      if (this.registerCallback) {
        this.registerCallback()
      }

      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
